import React, { memo } from 'react';
import cls from './MonthModePosition.module.css';
import classNames from 'classnames';
import { MonthItemPosition } from './MonthItemPosition';
import { useSelector } from 'react-redux';

export const MonthModePosition = memo(({ position }) => {
    const { months } = useSelector((state) => state.gantReducer);

    if (!position) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModePosition)}>
            <div className={classNames(cls.months)}>
                {months.map((year, i) => (
                    <div className={classNames(cls.months)} key={year.title + i}>
                        {year.month.map((item) => (
                            <MonthItemPosition
                                month={item}
                                isPlanFact={isPlanFact}
                                position={position}
                                key={item.date + Math.random().toString(36)}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
});
